module.exports = __webpack_public_path__ + "img/personal-roboport-equipment.20988dfa.png";